
/**
 *@key键名
 *@value值
 *@day过期时间
 *@path路径
 *@domain默认域名
 */
export function addCookie(key ,value , day ,path ,domain = document.domain ){

  if(document.domain === "www.winielts.com"){
    domain = '.winielts.com'
  }
  //1.处理默认保存的路径
  let index = window.location.pathname.lastIndexOf('/');
  let currentPath = window.location.pathname.slice(0,index);
  path = path || currentPath;

  //2.处理过期时间
  if(!day){
    document.cookie = `${key}=${value};path=${path};domain=${domain}`
  }else{
    let date = new Date()
    date.setDate(date.getDate() + day);
    document.cookie = `${key}=${value};expires=${date.toGMTString()}path=${path};domain=${domain}`
  }


}
/**
 *@key键名
 */
export function getCookie(key) {
  let val = ''
  let res = document.cookie.split(';')
  res.forEach((item,index)=>{
    item = item.split('=')
    // console.log(key);
    if(item[0].trim() === key){
      val = item[1]
    }
  })
  return val
}
/**
 *@如果修改过path则需要传递路径
 */
export function delCookie(key,path) {
  addCookie(key,getCookie(key),-1,path)
}

/**
 *@函数节流
 *@fn 需要执行的方法
 *@delay 执行方法延迟的时长
 */
export function throttle(fn, delay) {
  let timer = null;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(fn, delay);
  }
}



// WEBPACK FOOTER //
// ./src/api/cookie.js